import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import SolicitudesACComponent from './SolicitudesACComponent';
import { obtenerSolicitudesACEstatusNacional } from '../../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck';


function TabsSolicitudesAtendidasACComponent(props) {

    const dispatch = useDispatch()
    //const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.estatusSolicitudesAC)

    const [tabSolicitudes, setTabSolicitudes] = React.useState('estatus2');
    const [solicitudes, setSolicitudes] = React.useState([]);
    const solicitudesEstatus = []    

    
    React.useEffect(async () => {
        if (tabSolicitudes == 'estatus2'){
            let resEstatus2 = await dispatch(obtenerSolicitudesACEstatusNacional(2))
            setSolicitudes(resEstatus2?.payload)
        }
        if (tabSolicitudes == 'estatus3'){
            let resEstatus3 = await dispatch(obtenerSolicitudesACEstatusNacional(3))
            setSolicitudes(resEstatus3?.payload)
        }
        if (tabSolicitudes == 'estatus4'){
            let resEstatus4 = await dispatch(obtenerSolicitudesACEstatusNacional(4))
            setSolicitudes(resEstatus4?.payload)
        }
        if (tabSolicitudes == 'estatus5'){
            let resEstatus5 = await dispatch(obtenerSolicitudesACEstatusNacional(5))
            setSolicitudes(resEstatus5?.payload)
        }
        if (tabSolicitudes == 'estatus6'){
            let resEstatus6 = await dispatch(obtenerSolicitudesACEstatusNacional(6))
            setSolicitudes(resEstatus6?.payload)
        }
    }, [tabSolicitudes])
    

    const handleChangeSolicitudesTab = (event, newValue) => {
        setTabSolicitudes(newValue);
    };

    solicitudes?.fc_01_solicitudderegistro?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)

        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        let folio = ''
        /*if(solicitud?.idestatusdesolicitudes != 4)*/folio = solicitud.folio
        //else folio= solicitud?.informacionmodalaceptada?.numerosolicitudservicios

        solicitudesEstatus.push({
            id: uuidv4(), id: solicitud.idfc01_solicitudregistro, folio: folio,
            noSocio: solicitud.numerosocio !== undefined ? solicitud.numerosocio?.toString().length > 0 ? solicitud.numerosocio : '' : '',
            FechaDecreación: fecha, tipoSolicitud: 'Solicitud de inscripción', nombreRazon: solicitud.nombrerazonsocial,
            Nombre: 'fc_01_solicitudderegistro', idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
            estatus: estatus
        })
    })
    solicitudes?.fc_08_solicitudrenvacioncertificados?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc08_renvacioncertificado, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de renovación de certificados', nombreRazon: solicitud.nombrerazonsocial,
            noSocio: solicitud.numerocliente, Nombre: 'fc_08_solicitudrenvacioncertificados',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_33_solicitudenvasadonacional?.map(solicitud => {
        let revisor = ''
        let nombre = solicitud.revisor?.split(' ')
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), Folio: solicitud.idfc33_solicitudenvasadonaciona, folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
            idlogin: solicitud.idlogin, tipoSolicitud: 'Solicitud de venta nacional', Revisor: nombre?.[0] !== undefined ? revisor : '',
            nombreRazon: solicitud.nombrecliente, noSocio: solicitud.numerocliente, estatus: estatus
        })
    })
    solicitudes?.fc_36_solicituddeactualizacion?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let accion = ''
        if (solicitud.cambiorazon) accion = 'Cambio de razón social o régimen fiscal'
        else {
            if (solicitud.actualizaciondomicilio) accion = 'Actualización de domicilio fiscal'
            if (solicitud.cambioresponsable) accion = 'Actualización de persona autorizada para trámite'
            if (solicitud.cambiorepresentante) accion = 'Actualización de representante legal'
            if (solicitud.actualizarmedioscontacto) accion = 'Actualización medios de contacto'
            if (solicitud.actualizacioncadena) accion = 'Actualización de cadena productiva'
            if (solicitud.cambioresponsableinst) accion = 'Actualización de responsables de instalaciones'
            if (solicitud.actualizacioninstalaciones) accion = 'Alta o baja instalaciones'
            if (solicitud.actualizacionprediosviveros) accion = 'Baja predios/viveros'
            if (solicitud.actualizarmarcas) accion = 'Actualización de marcas'
        }

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        solicitudesEstatus.push({
            id: uuidv4(), Folio: solicitud.idfc36_solicitudactualizacion,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de actualización: ' + accion, noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_41_solicitudparabebidasconmezcal?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), Folio: solicitud.idfc41_solicitudparabebidasconm,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud para productos con mezcal', noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })

    })


    return (
        <Fragment>
            <Box sx={{ width: '80%', typography: 'body1', margin: 'auto', marginTop: '5%' }}>
                <TabContext value={tabSolicitudes}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeSolicitudesTab} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            <Tab label="Recibida en AC" value="estatus2" />
                            <Tab label="En revisión por AC" value="estatus3" />
                            <Tab label="Aceptada por AC" value="estatus4" />
                            <Tab label="Devuelta al cliente" value="estatus5"/>
                            <Tab label="Recibida corregida" value="estatus6"/>
                        </TabList>
                    </Box>
                    <TabPanel value="estatus2" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES RECIBIDAS EN AC" />
                    </TabPanel>
                    <TabPanel value="estatus3" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES EN REVISIÓN POR AC" />
                    </TabPanel>
                    <TabPanel value="estatus4" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES ACEPTADAS POR AC" />
                    </TabPanel>
                    <TabPanel value="estatus5" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES DEVUELTAS AL CLIENTE PARA CORRECCIÓN" /> 
                    </TabPanel>
                    <TabPanel value="estatus6" style={{paddingLeft: 0, paddingRight: 0}}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES RECIBIDAS CORREGIDAS POR EL CLIENTE" />
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}

export default withRouter(TabsSolicitudesAtendidasACComponent)